import React from 'react';
import { Combobox } from '@headlessui/react';

export const ComboboxErrorHintLabel: React.FC<{ hintText?: string; errorText?: string }> = ({
  hintText,
  errorText,
}) => {
  if (!!errorText) {
    return <Combobox.Label className="block text-xs text-red-700">{errorText}</Combobox.Label>;
  }
  return <Combobox.Label className="block text-xs text-gray-500">{hintText}</Combobox.Label>;
};
